module.exports = __webpack_public_path__ + "media/images/review-tool-modal-8a5f0311d823acd4dc3ace764afab2cb.png";